import { __decorate } from "tslib";
import { id_netscapeCertExtension } from "./object_identifiers";
import { AsnType, AsnTypeTypes, AsnPropTypes, AsnProp } from "@peculiar/asn1-schema";
export const id_netscapeCaPolicyUrl = `${id_netscapeCertExtension}.8`;
let NetscapeCaPolicyUrl = class NetscapeCaPolicyUrl {
    constructor(value) {
        this.value = "";
        if (value) {
            this.value = value;
        }
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], NetscapeCaPolicyUrl.prototype, "value", void 0);
NetscapeCaPolicyUrl = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], NetscapeCaPolicyUrl);
export { NetscapeCaPolicyUrl };
